"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawRGBABufferToCanvas = void 0;
const NATIVE_RTC = __importStar(require("@iris/native-rtc"));
const drawRGBABufferToCanvas = (width, height, buffer, format, canvas) => {
    const ctx = canvas.getContext('2d');
    if (!ctx) {
        return;
    }
    canvas.width = width;
    canvas.height = height;
    if (format == NATIVE_RTC.VIDEO_PIXEL_FORMAT.VIDEO_PIXEL_BGRA) {
        //下面是bgra转rgba的逻辑
        var rgbaArray = new Uint8ClampedArray(width * height * 4);
        for (var i = 0; i < buffer[0].length; i += 4) {
            rgbaArray[i] = buffer[0][i + 2];
            rgbaArray[i + 1] = buffer[0][i + 1];
            rgbaArray[i + 2] = buffer[0][i];
            rgbaArray[i + 3] = buffer[0][i + 3];
        }
        var imageData = new ImageData(rgbaArray, width, height);
        ctx.putImageData(imageData, 0, 0);
    }
    else if (format == NATIVE_RTC.VIDEO_PIXEL_FORMAT.VIDEO_PIXEL_RGBA) {
        var imageData = ctx.createImageData(width, height);
        for (var i = 0; i < buffer[0].length; i++) {
            imageData.data[i] = buffer[0][i];
        }
        ctx.putImageData(imageData, 0, 0);
    }
};
exports.drawRGBABufferToCanvas = drawRGBABufferToCanvas;
